import React from 'react';
import { TrackedLink } from 'components/common/TrackedLink';
import { useQueryAndHash } from './useQueryAndHash';
import { useWorkspacePath } from 'pages/workspaces/useWorkspace';
import { LinkHelperProps } from './index';

interface NewsLinkProps extends LinkHelperProps {
  slug?: string | null;
  climateBrief?: boolean;
}

export type { NewsLinkProps };

export function parseNewsPath(path: string) {
  // Parse news paths like /news/{slug} or /posts/{slug} or /climatebrief/{slug}
  const newsPathRegex = /^\/(?:news|posts|climatebrief)\/([^/]+)$/;
  const match = path.match(newsPathRegex);
  if (match) {
    return {
      slug: match[1],
      climateBrief: path.startsWith('/climatebrief'),
    };
  }
  return null;
}

export function useNewsPath(
  slug?: string | null,
  query?: string | null,
  hash?: string | null,
  climateBrief?: boolean | null,
) {
  const workspacePath = useWorkspacePath();

  const path = React.useMemo(() => {
    const postPrefix = climateBrief ? 'climatebrief' : slug ? 'posts' : 'news';
    return workspacePath + `/${postPrefix}/${slug || ''}`;
  }, [slug, workspacePath, climateBrief]);

  return useQueryAndHash(path, query, hash);
}

export function NewsLink({
  slug,
  to,
  query,
  hash,
  tabbable,
  onClick,
  climateBrief,
  ...props
}: NewsLinkProps) {
  const path = useNewsPath(slug, query, hash, climateBrief);

  return <TrackedLink to={to ? to : path} {...props} />;
}
